

import '../index.css';

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Route, useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { useAuth } from '../../../shared/AuthContext';
import rolePermissions from '../../../shared/rolePermissions';






const Component = ({ model }) => {

  const { slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');


  const { user, loadingSession } = useAuth();
  const canViewContent = rolePermissions.hasPermission(user, 'content.view');
  const canManageContent = rolePermissions.hasPermission(user, 'content.manage');


  const [record, setRecord] = useState(null);
  const [domain, setDomain] = useState(null);
  const [statusSaving, setStatusSaving] = useState(false);
  const [statusError, setStatusError] = useState('');

  useEffect(() => {

    const loadRecord = async () => {
      setLoading(true);
      setError('');
      try {

        const Service = {

          getRecord: async ( slug, setRecord ) => {

            const result = {};

            const Factory = require( '../../../records/modules' ).default;

            const row = await Factory( {
              slug: model.slug
            } ).Meta.getRecord( slug );

            result.data = row;

            setRecord( result );
          },

          getDomain: async ( slug, setDomain ) => {

            const result = {};

            const Factory = require( '../../../records/modules' ).default;

            const row = await Factory( {
              slug: model.slug
            } ).Meta.getRecord( slug );

            model.domain.forEach( ( item ) => {
              result[ item.handle ] = row[ item.handle ] ?? item.defaultValue ?? (['table', 'list'].includes(item.domain.value) ? [] : {});
            } );

            setDomain( result );
          },

        };

        await Service.getRecord(slug, setRecord);
        await Service.getDomain(slug, setDomain);
      } catch (err) {
        setError(`Record Error: ${err?.response?.data?.message || err.message || 'Unable to load Record.'}`);
      } finally {
        setLoading(false);
      }
    };

    loadRecord();
  }, [ model, slug ]);











  const RecordViewSection = require( '../../../components/record/RecordViewSection' ).default;

  if (loadingSession) return <p>Checking access...</p>;
  if (!canViewContent) return <p className="error-text">You do not have permission to view this content.</p>;
  
  if (loading) return <p>Loading Record...</p>;

  if (error) return <p className="error-text">{error}</p>;
  if (!record) return <p className="error-text">Record not found.</p>;

  const {
    handle,
    details
  } = {
    handle: {
      slug: model.slug,
      handle: model.handle,
      status: model.status,
      details: model.fields,
    },
    section: model.section,
    slug: model.slug,
    details: {
      items: model.domain
    }
  };

  return (
    <RecordViewSection
      slug={handle.slug}
      header={{
        editTo: `/${handle.slug}/${record.data?.slug || slug}/edit`
      }}
      canUpdateContent={canManageContent}
      data={{
        record: record,
        hasStatus: true,
        status: {
          value: record.data.status,
          options: handle.status.options,
          onSubmit: async (status) => {
            setStatusSaving(true);
            setStatusError('');
            try {
              const Factory = require( '../../../records/modules' ).default;

              const updated = await Factory( {
                slug: model.slug
              } ).Meta.updateRecord( slug, { status } );

              setRecord({ data: updated });
            } catch (err) {
              setStatusError(`Status Error: ${err?.response?.data?.message || err.message || 'Unable to update Record status.'}`);
            } finally {
              setStatusSaving(false);
            }
          },
          saving: statusSaving,
          error: statusError,
        },
        handle: {
          handle: handle.handle.handle,
          label: handle.handle.label,
          meta: handle.handle.field.meta,
          value: handle.handle.field.value,
        },
        details: handle.details.map( ( field ) => ({
          handle: field.handle,
          label: field.label,
          meta: field.field.meta,
          value: field.field.value,
        }) )
      }}
    >

      {details.items.map( ( domainItem ) => {

        const Components = require( '../../../elements' ).default;

        const Component = Components.Meta.domain( domainItem.domain.value );

        return <Component.Output key={domainItem.handle} handle={domainItem.handle} meta={domainItem.domain.meta} domain={domain || record.data} />;
      } )}

    </RecordViewSection>
  );
};


export default Component;